/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectProgressCommand } from '../../models/create-project-progress-command';
import { CreateProjectProgressCommandResult } from '../../models/create-project-progress-command-result';

export interface ApiProjectProgressCreateProgressPost$Plain$Params {
      body?: CreateProjectProgressCommand
}

export function apiProjectProgressCreateProgressPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectProgressCreateProgressPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectProgressCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectProgressCreateProgressPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectProgressCommandResult>;
    })
  );
}

apiProjectProgressCreateProgressPost$Plain.PATH = '/api/ProjectProgress/CreateProgress';
